/** Named in the access-denied toast when a role outside INTERNAL_ROLES opens this module (ADR-0014). */
export const NOTIFICATIONS_PAGE_NAME = 'Notifications';
